// imports react
import React from 'react';

//imports libraries
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner';

import styles from '../styles/evokchat.module.css';

export function ContainerSuggestions({header, title, body, colorIcon, handleClickSuggestion}) {
    const iconWithColor = React.cloneElement(header, { color: colorIcon, size: 20});

    return (
        <div className={styles.containerSuggestions} onClick={() => handleClickSuggestion(body)}>
            <div className={styles.containerSuggestionsHeader}>
                {iconWithColor}
            </div>
            <div className={styles.containerSuggestionsBody}>
                {title}
            </div>
        </div>
    );
}
